<div class="backdrop" *ngIf="aberto">
  <div class="dialog">
    <h2>{{ titulo }}</h2>
    <p>{{ mensagem }}</p>
    <div class="buttons">
      <button #fecharBtn (click)="fechar()">{{ this.botaoFechar | translate }}</button>
    </div>
  </div>
</div>
